import { defineMessages } from 'react-intl';

export default defineMessages({
    documentTitle: {
        defaultMessage: 'No access',
        description: 'Document title for user with no access to portal',
        id: 'cv.portal.forbidden.access.document.title',
    },
    errorHeading: {
        defaultMessage: 'No access',
        description: 'Error heading for user with no portal access',
        id: 'cv.portal.forbidden.access.error.heading',
    },
    errorDescription: {
        defaultMessage:
            "It seems that your account {userEmail} doesn't have access to the help center." +
            '<br/>' +
            'Try contacting your admins to grant you permissions.',
        description: 'Error descripion for user with no portal access',
        id: 'cv.portal.forbidden.access.error.description',
    },
    callToActionText: {
        defaultMessage: 'Go to Atlassian Start',
        description: 'Next action link label for user with no portal access',
        id: 'cv.portal.forbidden.access.error.action.link.label',
    },
});
